import React from "react";
import { X } from "lucide-react";

// Shared 3D-style modal close button. Renders a raised, glossy circular button
// with a bold red X and tactile hover/press feedback. Absolutely positioned in
// the top-right of its (relatively-positioned) container by default; pass
// `style` to override position/offsets.
const BASE_SHADOW = "0 4px 9px rgba(0,0,0,0.3), inset 0 1px 1px rgba(255,255,255,0.9), inset 0 -3px 4px rgba(0,0,0,0.15)";
const HOVER_SHADOW = "0 6px 14px rgba(0,0,0,0.35), inset 0 1px 1px rgba(255,255,255,0.9), inset 0 -3px 4px rgba(0,0,0,0.18)";
const PRESS_SHADOW = "0 1px 3px rgba(0,0,0,0.3), inset 0 2px 4px rgba(0,0,0,0.2)";

const CloseButton = ({ onClick, style = {}, iconSize = "1.15rem", ariaLabel = "Close", ...props }) => (
    <button
        type="button"
        onClick={onClick}
        aria-label={ariaLabel}
        onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-1px)"; e.currentTarget.style.boxShadow = HOVER_SHADOW; }}
        onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = BASE_SHADOW; }}
        onMouseDown={e => { e.currentTarget.style.transform = "translateY(1px)"; e.currentTarget.style.boxShadow = PRESS_SHADOW; }}
        onMouseUp={e => { e.currentTarget.style.transform = "translateY(-1px)"; e.currentTarget.style.boxShadow = HOVER_SHADOW; }}
        style={{ position: "absolute", top: "0.85rem", right: "0.85rem", width: "2.1rem", height: "2.1rem", background: "linear-gradient(145deg,#ffffff,#e4e7ec)", border: "none", borderRadius: "9999px", cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center", padding: 0, boxShadow: BASE_SHADOW, transition: "transform 0.12s ease, box-shadow 0.12s ease", ...style }}
        {...props}
    >
        <X style={{ width: iconSize, height: iconSize, color: "#dc2626", strokeWidth: 3 }} />
    </button>
);

export default CloseButton;
